// removed by extract-text-webpack-plugin
module.exports = {"base":"ButtonInbox_base--1E8K7","base__new-message":"ButtonInbox_base__new-message--2lOdK","baseNewMessage":"ButtonInbox_base__new-message--2lOdK","icon":"ButtonInbox_icon--11djI","messages":"ButtonInbox_messages--PpdVz"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/ButtonInbox/ButtonInbox.css
// module id = 1743
// module chunks = 16